import { css } from '@emotion/core'
import theme from 'Theme'
import { mediumUp } from 'Utils'
import config from 'Config'

const flexJustifyRule = config.instalooksEnabled ? 'space-between' : 'center'
const buttonMargin = config.instalooksEnabled ? '0' : '1rem'

const { typography, spacing, mixins } = theme

const defaultVariantSkin = () => css`
  display: flex;
  margin: 0 auto ${spacing.vertical.medium} auto;
  justify-content: ${flexJustifyRule};
  max-width: 475px;

  .content-links__link {
    ${mixins.defaultButton(theme)}
    padding: .5rem 2.8rem;
    display: block;
    width: 100%;
    padding: 0.5rem 0.5rem;
    margin: 0;
  }

  .content-links__item {
    &:first-of-type {
      margin-right: ${buttonMargin};
    }
    width: 32%;
    @media ${mediumUp} {
      width: 31%;
    }

    &.current {
      .content-links__link {
        background-color: black;
        color: white;
      }
    }
  }

  button {
    font-size: ${typography.baseFontSize};
  }
`

export default defaultVariantSkin
